import { render, staticRenderFns } from "./UnitStatistics.vue?vue&type=template&id=00194ad9&scoped=true"
import script from "./UnitStatistics.vue?vue&type=script&lang=js"
export * from "./UnitStatistics.vue?vue&type=script&lang=js"
import style0 from "./UnitStatistics.vue?vue&type=style&index=0&id=00194ad9&prod&lang=less&scoped=true"
import style1 from "./UnitStatistics.vue?vue&type=style&index=1&id=00194ad9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00194ad9",
  null
  
)

export default component.exports